<template>
    <div id="comments_wrapper" class="bottom_content">
        <p class="content_title">Comments</p>
        <div class="content_inner">
            <!-- 新增留言start -->
            <comment-input :nid="nid" @reload-comment="reloadComment" :is-login="isLogin" :is-premium="isPremium" @show-login="showLogin" :avatar="avatar"></comment-input>
            <!-- 新增留言end -->
            <!-- 留言列表 start -->
            <comment-list :comment-list="commentList" :init-loading="init_loading" :total="commentTotal"></comment-list>

            <img src="/images/ajax-loader.gif" class="loading_indicator" alt="" v-show="loading">
            <!-- 留言列表 end -->
            <comment-more-btn v-show="hasMore" @load-more="loadMore"></comment-more-btn>
        </div>
    </div>
</template>

<script>
    import { commentGet } from '@vuePath/api/article';
    import { convertDateToFormat } from '@vuePath/tools/tool';
    import CommentInput from './CommentInput';
    import CommentList from './CommentList';
    import CommentMoreBtn from './CommentMoreBtn';
    import { useStore } from 'vuex';

    export default {
        props: {
            nid: {
                type: String
            }
        },
        setup(props) {
            const store = useStore();

            const isLogin = store.getters['auth/isAuthenticated'];

            const isPremium = store.getters['auth/isPremium'];

            const showLogin = () => { store.dispatch('auth/ShowLogin'); };

            const avatar = store.getters['auth/avatar'];

            return { isLogin, isPremium, showLogin, avatar };
        },
        mounted() {
            this.init_loading = true;
            this.loading = true;
            this.getCommentList();
        },
        data() {
            return {
                init_loading: false,
                commentList: [],
                loading: true,
                hasMore: false,
                commentTotal: 0,
                currentID: 0,
                size: 3,
                showMore: false
            }
        },
        components: {
            CommentList,
            CommentMoreBtn,
            CommentInput
        },
        methods: {
            getCommentList() {
                return new Promise((resolve, reject) => {
                    commentGet(this.nid, this.currentID, this.size)
                        .then(res => {
                            if (this.currentID === 0) {
                                this.init_loading = false;
                            }

                            if ((res.data.code === '000') && (res.data.data.article_comment.length !== 0)) {
                                let data = res.data.data;
                                this.commentList = this.commentList.concat(data.article_comment);
                                this.currentID = this.commentList[this.commentList.length - 1]['id'];
                                this.commentTotal = data.total;
                                this.hasMore = (data.has_more === 'true');
                            }
                            this.loading = false;
                            resolve(res);
                        })
                        .catch(function (err) {
                            reject(err);
                        });
                });
            },
            convertTimestampToFormat(timestamp) {
                return convertDateToFormat(timestamp, 'M j, Y, H:i');
            },
            loadMore() {
                this.hasMore = false;
                let lastCommentID = this.commentList.length - 1;
                let anchor = document.querySelector('[data-order="'+lastCommentID+'"]');
                this.size = this.commentTotal - this.commentList.length;
                this.loading = true;
                this.getCommentList()
                    .then(res => {
                        anchor.scrollIntoView();
                    });
            },
            reloadComment() {
                this.hasMore = false;
                this.resetCommentList();
                this.getCommentList();
            },
            resetCommentList() {
                this.size = this.commentList.length + 1;
                this.currentID = 0;
                this.commentList= [];
            }
        }
    }
</script>
